/**
 * Internal dependencies
 */
import HomePage from '../pages/HomePage';
import SettingsPage from "../pages/SettingsPage";

const routes = [
    {
        path: '/',
        element: HomePage,
    },
    {
        path: '/settings',
        element: SettingsPage,
    },
];

export default routes;
